// src/component/PaginaRevista/imagenesRevista.js
function importAll(r) {
  return r.keys().map(r);
}

export const imagenesEventosSC = importAll(
  require.context('../../assets/eventosScz', true, /\.(png|jpe?g|svg)$/)
);